import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { MapSelectionMode } from 'components/KNMapLibre/types'
import { t } from 'i18next'
import { type ReactNode } from 'react'

export interface LaneOrRegionDialogModeSwitcherProps {
  mode?: MapSelectionMode
  onModeChange: (mode?: MapSelectionMode) => void
}

const LaneOrRegionDialogModeSwitcher = ({
  mode,
  onModeChange,
}: LaneOrRegionDialogModeSwitcherProps): ReactNode => (
  <Stack direction="row" spacing={1}>
    <Button
      variant={mode === MapSelectionMode.SOURCE ? 'contained' : 'outlined'}
      size="small"
      color="secondary"
      fullWidth
      onClick={() => onModeChange(mode === MapSelectionMode.SOURCE ? undefined : MapSelectionMode.SOURCE)}
    >
      {t('screens.cs.carrier_profile.lanes_and_regions.form.select_country')}
    </Button>
    <Button
      variant={mode === MapSelectionMode.CIRCLE ? 'contained' : 'outlined'}
      size="small"
      color="secondary"
      fullWidth
      onClick={() => onModeChange(mode === MapSelectionMode.CIRCLE ? undefined : MapSelectionMode.CIRCLE)}
    >
      {t('screens.cs.carrier_profile.lanes_and_regions.form.select_circle')}
    </Button>
  </Stack>
)

export default LaneOrRegionDialogModeSwitcher
